
export class GameTypeAbstract {
}
